import { Fragment } from 'react';
import { track } from '../../tracking';
import { AntTooltip } from '../../components/common/AntTooltip';

export const FetchingLoader: React.FC<{ isFetchingProfile?: boolean }> = ({
    isFetchingProfile,
}) => {
    return isFetchingProfile ? (
        <div className="absolute inset-0 z-50 flex items-center justify-center opacity-50 bg-white">
            <svg
                className="w-28 h-28 fill-darwin-primary-500 animate-spin"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
            >
                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
            </svg>
        </div>
    ) : null;
};

export const Stepper: React.FC<{ currentIndex: number }> = ({ currentIndex }) => {
    return (
        <div className="flex items-center space-x-4 h-5">
            {new Array(4).fill(1).map((i, index) => {
                return (
                    <div
                        className={`flex-1 h-full ${
                            currentIndex > index
                                ? 'popup-overlay-show bg-darwin-accent-bright-blue-800'
                                : 'bg-darwin-neutral-200'
                        }`}
                    ></div>
                );
            })}
        </div>
    );
};

export const Header: React.FC<{
    saveAndExitHandler: () => Promise<void>;
    exitHandler?: () => void;
    disabled?: boolean;
    isSavingProfile?: boolean;
    buttonText?: string;
    showBg?: boolean;
    onMyOrdersCTAClick?: () => void;
}> = ({
    saveAndExitHandler,
    disabled,
    isSavingProfile,
    buttonText,
    exitHandler,
    showBg,
    onMyOrdersCTAClick,
}) => {
    const onClick = () => {
        exitHandler ? exitHandler() : saveAndExitHandler();
        track('HE_ONBOARDING_SAVE_AND_EXIT', { buttonText: buttonText || 'Save & Exit' });
    };
    return (
        <div className="grid grid-cols-2 gap-x-24">
            <div className="pt-32 pl-48 pb-40 flex items-center justify-start">
                <svg
                    className="w-30 h-32 fill-darwin-accent-bright-blue-800"
                    viewBox="0 0 29 32"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M28.2762 20.1024C28.0081 19.6075 27.6727 19.1554 27.2819 18.7581L25.1689 16.6319L23.1371 18.6764L25.225 20.7773C25.7817 21.3369 26.1258 22.1104 26.1258 22.9651C26.1258 23.8198 25.8063 24.537 25.2846 25.0919L25.2828 25.0936C25.2636 25.1136 25.2443 25.1336 25.225 25.1536C23.8773 26.5432 22.2246 27.6331 20.3763 28.3138C18.9807 28.8275 17.4729 29.1079 15.9009 29.1079C14.5683 29.1079 13.2831 28.9069 12.0727 28.5324C11.0808 28.2268 10.1402 27.8041 9.26514 27.2821C5.43932 24.9984 2.87418 20.8008 2.87418 16C2.87418 11.1992 5.43932 7.00099 9.26514 4.71729C10.1432 4.19354 11.0878 3.77031 12.0832 3.46405C13.2907 3.09137 14.573 2.89151 15.9015 2.89151C17.4694 2.89151 18.9725 3.17014 20.3646 3.68096C22.2171 4.36107 23.8732 5.45149 25.2233 6.84404C25.2414 6.86227 25.2589 6.88049 25.2764 6.89871C25.8028 7.4542 26.1258 8.20603 26.1258 9.03428C26.1258 9.86252 25.7817 10.662 25.225 11.2222L24.7524 11.6983L22.5091 13.955L17.6184 9.03369C17.4577 8.8738 17.2883 8.72332 17.1107 8.58224C16.0995 7.7828 14.8236 7.30549 13.4374 7.30549C12.9455 7.30549 12.4676 7.36544 12.0102 7.47948C11.6848 7.55943 11.3699 7.667 11.0685 7.79926C11.0451 7.80925 11.0218 7.81983 10.999 7.83041C8.92923 8.76682 7.48806 10.8601 7.48806 13.2919C7.48806 13.4406 7.49331 13.5882 7.50441 13.7345C7.50441 13.7404 7.50499 13.7463 7.50558 13.7527C7.50792 13.7886 7.51142 13.8245 7.51493 13.8603C7.5897 14.501 7.97935 15.0454 8.52381 15.3316C8.78669 15.4698 9.08579 15.548 9.403 15.548H9.40593C9.96616 15.5474 10.4703 15.3023 10.8173 14.9131C11.1199 14.5751 11.3039 14.1272 11.3039 13.6358C11.3039 13.4647 11.2817 13.2995 11.2403 13.142C11.1334 12.7393 10.8991 12.3884 10.5836 12.1368C11.0387 11 12.1446 10.1976 13.4374 10.1976C14.2868 10.1976 15.0556 10.5438 15.6123 11.104L20.4774 15.9994L19.2138 17.2709L15.586 20.9213C15.0316 21.4662 14.2733 21.8018 13.4374 21.8018C12.9934 21.8018 12.571 21.7072 12.1896 21.5367C12.1872 21.5355 12.1843 21.5344 12.1814 21.5332C11.457 21.2064 10.881 20.6062 10.5836 19.8632C10.8991 19.611 11.1334 19.2607 11.2403 18.8574C11.2817 18.7005 11.3039 18.5347 11.3039 18.3642C11.3039 17.8728 11.1199 17.4249 10.8173 17.0863C10.4703 16.6977 9.96733 16.4526 9.4071 16.4515H9.403C9.08579 16.4515 8.78669 16.5296 8.52381 16.6678C7.9776 16.9552 7.58737 17.5019 7.51434 18.145C7.51376 18.1532 7.51259 18.1608 7.512 18.1685C7.50967 18.1944 7.50733 18.2196 7.50558 18.2455C7.50558 18.2525 7.50558 18.259 7.50441 18.2655C7.49331 18.4113 7.48806 18.5588 7.48806 18.7069C7.48806 21.1388 8.92923 23.2326 10.999 24.169L11.0685 24.2002C11.3699 24.3324 11.6848 24.44 12.0102 24.5199C12.4676 24.634 12.9455 24.6939 13.4374 24.6939C14.8271 24.6939 16.1053 24.2148 17.1177 23.4113C17.2141 23.3349 17.3082 23.2549 17.3999 23.1721L17.4022 23.1697L21.8216 18.7228L22.5027 18.0374L24.5345 15.9929L25.1362 15.3881L25.6637 14.8573L27.2504 13.2602C27.6529 12.8551 27.9981 12.3919 28.2727 11.8846C28.7319 11.0352 28.993 10.0618 28.993 9.02722C28.993 8.5358 28.934 8.05849 28.823 7.60175C28.5724 6.56894 28.056 5.64135 27.3503 4.89717C27.3287 4.87424 27.307 4.8519 27.2843 4.82957C27.2813 4.82663 27.279 4.82428 27.2767 4.82134C27.2586 4.8037 27.241 4.78548 27.2235 4.76785C27.2194 4.76314 27.2153 4.75962 27.2112 4.75609C24.3289 1.8199 20.3266 0 15.9015 0C13.754 0 11.7064 0.427936 9.83764 1.20445C8.90353 1.59242 8.0144 2.06738 7.17961 2.61876C2.8549 5.47911 0 10.4039 0 16C0 21.5961 2.8549 26.5209 7.17961 29.3807C8.01148 29.9303 8.89769 30.4041 9.82829 30.7908C11.6994 31.5703 13.7505 32 15.9015 32C20.35 32 24.3721 30.1613 27.2574 27.1981L27.2708 27.1845C27.2802 27.1751 27.2895 27.1651 27.2989 27.1557C27.317 27.1375 27.3351 27.1187 27.3526 27.0999C27.3596 27.0934 27.366 27.0864 27.3725 27.0787C28.0676 26.3398 28.5776 25.4222 28.8271 24.4012C28.9404 23.9409 29 23.4601 29 22.9651C29 21.9282 28.7377 20.953 28.2768 20.1024H28.2762Z" />
                </svg>
            </div>

            <div
                className={`space-x-12 pt-32 pr-48 pb-40 flex items-center justify-end ${
                    showBg ? 'bg-darwin-neutral-50' : ''
                }`}
            >
                {onMyOrdersCTAClick && (
                    <AntTooltip content="See you recent Order">
                        <button
                            className="px-16 py-10 text-white bg-darwin-accent-bright-blue-800 rounded-4 font-700"
                            onClick={onMyOrdersCTAClick}
                        >
                            My Orders
                        </button>
                    </AntTooltip>
                )}
                <button
                    className={`flex items-center space-x-12 px-16 py-10 border border-darwin-neutral-900 font-700 rounded-4 ${
                        disabled ? 'opacity-70' : ''
                    } bg-white`}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {isSavingProfile && (
                        <svg
                            className="w-14 h-14 fill-darwin-neutral-1000 animate-spin"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                        </svg>
                    )}
                    <p>{buttonText || 'Save & Exit'}</p>
                </button>
            </div>
        </div>
    );
};

export const Footer: React.FC<{
    onClickHandler: () => Promise<void>;
    onSkipAndStartHandler?: () => Promise<void>;
    onSaveChangesHandler?: () => Promise<void>;
    onBackHandler?: () => void;
    disabled?: boolean;
    isSavingProfile?: boolean;
    isSavingChanges?: boolean;
    isSkipAndNextLoading?: boolean;
    buttonText?: string;
    currentIndex: number;
    saveButtonText?: string;
    isWarningBt?: boolean;
}> = ({
    onClickHandler,
    onSkipAndStartHandler,
    onSaveChangesHandler,
    onBackHandler,
    disabled,
    isSavingProfile,
    isSavingChanges,
    isSkipAndNextLoading,
    buttonText,
    currentIndex,
    saveButtonText,
    isWarningBt,
}) => {
    const onBack = () => {
        onBackHandler && onBackHandler();
        track('HE_ONBOARDING_GO_BACK');
    };

    const onClick = () => {
        onClickHandler && onClickHandler();
        track('HE_ONBOARDING_NEXT_PAGE', { buttonText: buttonText || 'Save & Exit' });
    };

    const onSkipAndStart = () => {
        onSkipAndStartHandler && onSkipAndStartHandler();
        track('HE_ONBOARDING_SKIP_AND_START');
    };
    return (
        <Fragment>
            <Stepper currentIndex={currentIndex} />
            <div className="flex items-center justify-between px-48 py-16">
                {onBackHandler && (
                    <p className="font-700 cursor-pointer" onClick={onBack}>
                        Back
                    </p>
                )}
                <div className="flex items-center space-x-32 text-13 text-darwin-neutral-700">
                    <div className="flex items-center space-x-8">
                        <div>
                            <svg
                                className="w-14 h-14 fill-darwin-neutral-400"
                                viewBox="0 0 14 14"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7 13.625C3.39453 13.625 0.5 10.7305 0.5 7.125C0.5 3.54492 3.39453 0.625 7 0.625C10.5801 0.625 13.5 3.54492 13.5 7.125C13.5 10.7305 10.5801 13.625 7 13.625ZM9.86914 5.93164H9.84375C10.0977 5.70312 10.0977 5.32227 9.84375 5.06836C9.61523 4.83984 9.23438 4.83984 9.00586 5.06836L6.1875 7.91211L4.99414 6.71875C4.74023 6.46484 4.35938 6.46484 4.13086 6.71875C3.87695 6.94727 3.87695 7.32812 4.13086 7.55664L5.75586 9.18164C5.98438 9.43555 6.36523 9.43555 6.61914 9.18164L9.86914 5.93164Z" />
                            </svg>
                        </div>
                        <p className="space-x-4">
                            <span>100%</span>
                            <span className="text-darwin-neutral-1000">transparency</span>
                        </p>
                    </div>

                    <div className="flex items-center space-x-8">
                        <div>
                            <svg
                                className="w-14 h-14 fill-darwin-neutral-400"
                                viewBox="0 0 14 14"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7 13.625C3.39453 13.625 0.5 10.7305 0.5 7.125C0.5 3.54492 3.39453 0.625 7 0.625C10.5801 0.625 13.5 3.54492 13.5 7.125C13.5 10.7305 10.5801 13.625 7 13.625ZM9.86914 5.93164H9.84375C10.0977 5.70312 10.0977 5.32227 9.84375 5.06836C9.61523 4.83984 9.23438 4.83984 9.00586 5.06836L6.1875 7.91211L4.99414 6.71875C4.74023 6.46484 4.35938 6.46484 4.13086 6.71875C3.87695 6.94727 3.87695 7.32812 4.13086 7.55664L5.75586 9.18164C5.98438 9.43555 6.36523 9.43555 6.61914 9.18164L9.86914 5.93164Z" />
                            </svg>
                        </div>
                        <p className="space-x-4">
                            <span>No additional</span>
                            <span className="text-darwin-neutral-1000">operational complexity</span>
                        </p>
                    </div>

                    <div className="flex items-center space-x-8">
                        <div>
                            <svg
                                className="w-14 h-14 fill-darwin-neutral-400"
                                viewBox="0 0 14 14"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7 13.625C3.39453 13.625 0.5 10.7305 0.5 7.125C0.5 3.54492 3.39453 0.625 7 0.625C10.5801 0.625 13.5 3.54492 13.5 7.125C13.5 10.7305 10.5801 13.625 7 13.625ZM9.86914 5.93164H9.84375C10.0977 5.70312 10.0977 5.32227 9.84375 5.06836C9.61523 4.83984 9.23438 4.83984 9.00586 5.06836L6.1875 7.91211L4.99414 6.71875C4.74023 6.46484 4.35938 6.46484 4.13086 6.71875C3.87695 6.94727 3.87695 7.32812 4.13086 7.55664L5.75586 9.18164C5.98438 9.43555 6.36523 9.43555 6.61914 9.18164L9.86914 5.93164Z" />
                            </svg>
                        </div>
                        <p className="space-x-4">
                            <span>End-to-end</span>
                            <span className="text-darwin-neutral-1000">customer support</span>
                            <span>powered by Eka</span>
                        </p>
                    </div>
                </div>
                <div className="flex items-center space-x-16">
                    {onSaveChangesHandler && (
                        <button
                            className={`flex items-center justify-center space-x-12 min-w-160 py-14 px-32 font-700 ${
                                isWarningBt
                                    ? 'bg-darwin-status-warning-500'
                                    : 'bg-darwin-accent-bright-blue-800'
                            } rounded-4 text-white ${
                                isSavingChanges || isSavingProfile ? 'opacity-70' : ''
                            }`}
                            disabled={isSavingChanges || isSavingProfile}
                            onClick={onSaveChangesHandler}
                        >
                            {isSavingChanges && (
                                <svg
                                    className="w-16 h-16 fill-white animate-spin"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                </svg>
                            )}
                            <p>{saveButtonText}</p>
                        </button>
                    )}
                    {onSkipAndStartHandler && (
                        <button
                            className={`flex items-center justify-center space-x-12 min-w-160 py-14 px-32 font-700 bg-darwin-accent-bright-blue-800 rounded-4 text-white ${
                                disabled ? 'opacity-70' : ''
                            }`}
                            disabled={disabled}
                            onClick={onSkipAndStart}
                        >
                            {isSkipAndNextLoading && (
                                <svg
                                    className="w-16 h-16 fill-white animate-spin"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                </svg>
                            )}
                            <p>Skip &amp; Start</p>
                        </button>
                    )}
                    <button
                        className={`flex items-center justify-center space-x-12 min-w-160 py-14 px-32 font-700 bg-darwin-accent-bright-blue-800 rounded-4 text-white ${
                            disabled ? 'opacity-70' : ''
                        }`}
                        disabled={disabled}
                        onClick={onClick}
                    >
                        {isSavingProfile && (
                            <svg
                                className="w-16 h-16 fill-white animate-spin"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                            </svg>
                        )}
                        <p>{buttonText || 'Next'}</p>
                    </button>
                </div>
            </div>
        </Fragment>
    );
};
